import {openSolutionDrawer} from '@/modules/drug-catalog/solutions/components'
import {openActiveSubstanceDrawer} from '@/modules/drug-catalog/substances/components/active-substance-drawer/util'
import {openSupportiveMedicationDrawer} from '@/modules/drug-catalog/supportive-medications/components/supportive-medication-drawer/util'
import {CatalogType} from '@cypro/engine/database/schema'
import {DrugCatalogItem} from '@cypro/engine/schema'
import {ResourceTag, ResourceTagProps} from '@cypro/ui/components/ui/tags/resource-tag'

export interface DrugTagProps extends Omit<ResourceTagProps, 'onClick'> {
  drug?: DrugCatalogItem
}

export function DrugTag({drug, ...props}: DrugTagProps) {
  function onClick() {
    if (!drug) return

    switch (drug.catalogType) {
      case CatalogType.enum.ACTIVE_SUBSTANCE:
        return openActiveSubstanceDrawer(drug)
      case CatalogType.enum.SOLUTION:
        return openSolutionDrawer(drug)
      case CatalogType.enum.SUPPORTIVE_MEDICATION:
        return openSupportiveMedicationDrawer(drug)
      default:
        return null
    }
  }

  return (
    <ResourceTag {...props} onClick={onClick} data-e2e="drug-tag" data-drug-id={drug?.id}>
      {drug?.name}
    </ResourceTag>
  )
}
